/* src/app/reconciliation/reconciliation-file-format/reconciliation-file-format.component.scss */
body#themeTag :host ::ng-deep .p-datatable .p-datatable-scrollable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-header,
body#themeTag :host ::ng-deep .p-datatable .p-datatable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-header {
  height: 3em;
}
/*# sourceMappingURL=reconciliation-file-format.component.css.map */
